import React from 'react';

import withCard from './WithCard';
import OpenChoice from '../../../Types/Components/OpenChoice';

const OpenChoiceCard = (props) => {
  return <OpenChoice {...props} />
}

export default withCard(OpenChoiceCard);